import { userApis } from "@payping/api";
import { LeftOutlined } from "@payping/icons";
import { webConstants } from "@payping/utils/platformConstants";
import { Card, Tag, Typography } from "@payping/web-components";
import { FC, useEffect } from "react";
import { useAsync } from "react-use";
import { safeJoinPath } from "@payping/utils/string";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { consultingCardId, notificationCardId } from "@/assets/googleTrackIds";
import { CustomLink } from "@/components/CustomLink";

interface Props {
  setShowBlogPost: (value: boolean) => void;
}

const NotificationCard: FC<Props> = ({ setShowBlogPost }) => {
  const { t } = useAppTranslation();

  const { value: data } = useAsync(() => userApis.messageWithoffsetWithlimitGet(0, 1), []);

  const hasUnseenMessage = data?.messages?.length ? !data.messages[0].isSeen : false;
  const messageToShow = hasUnseenMessage ? data?.messages?.[0].description : "";

  useEffect(() => {
    if (messageToShow) {
      setShowBlogPost(false);
    }
  }, [messageToShow, setShowBlogPost]);

  return (
    <CustomLink
      style={{ color: "unset", textDecoration: "none" }}
      to={
        messageToShow
          ? webConstants.DashboardRoutes.home.messages
          : safeJoinPath(
              webConstants.WP_LANDING_URL,
              "tax-advice/?utm_source=Dashboad&utm_medium=banner&utm_campaign=tax"
            )
      }
      data-google-track={messageToShow ? notificationCardId : consultingCardId}
    >
      <Card.Raw
        clickable
        background={
          // eslint-disable-next-line no-nested-ternary
          hasUnseenMessage
            ? "linear-gradient(239deg, #E31B23 0%, #FF6066 100%)"
            : !messageToShow
            ? "linear-gradient(301deg, #0080FF 0%, #2E97FF 100%)"
            : undefined
        }
      >
        {messageToShow ? (
          <>
            <Card.Raw.ColMeta
              header={
                <Card.Raw.RowMeta title={t("overview.notificationCard.title")} childrenJustify="flex-start">
                  {hasUnseenMessage ? (
                    <Tag style={{ backgroundColor: "white" }}>{t("overview.notificationCard.badge")}</Tag>
                  ) : null}
                </Card.Raw.RowMeta>
              }
            >
              <Typography.Paragraph
                className={"color--white"}
                ellipsis={{ rows: 2 }}
                style={{ marginBottom: 0, padding: "0 1vw" }}
              >
                {messageToShow}
              </Typography.Paragraph>
            </Card.Raw.ColMeta>
            <Card.Raw.RowMeta showTopBorder title={t("overview.notificationCard.messagesPageButton")}>
              <LeftOutlined height="15px" />
            </Card.Raw.RowMeta>
          </>
        ) : (
          <Card.Raw.RowMeta>
            {`${t("overview.promotion")} `}
            <LeftOutlined height="15px" />
          </Card.Raw.RowMeta>
        )}
      </Card.Raw>
    </CustomLink>
  );
};

export default NotificationCard;
